export * from './rewards-link.styled.default';
